import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionEquipment, constructionSafety } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import video from '@src/assets/images/solution/logisticsAsset/video/rtlsVideo.mp4';

export default {
  desc: 'Smart Building (Toà nhà thông minh) là những tòa nhà sử dụng các công nghệ như cảm biến IoT, Trí tuệ nhân tạo (AI) và hệ thống tự động hóa để kết nối và tích hợp các hệ thống khác nhau trong tòa nhà, từ đó tối ưu hóa vận hành.',
  keywords: 'Smart Building,Tòa nhà thông minh,Toa nha thong minh,IoT,Theo dõi vị trí,Theo doi vi tri,DigitalTwin',
  ogSite: 'Smart Building là gì?',
  title: 'Smart Building là gì?',
  ogUrl: 'https://orbro.io/vi/blog/smart-buildings',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDmNclLyXvFXAppGJYrqUeCnj1ItMcBFHWPvVUo5mAAclWqqXT2c7O3kn8SC3hs6LiHgOw7HC2-KUOHZpCjEK7FnzMSWAna_xAxwzmLzRZvzyR4y1i-8TbhmLBCUAAEfPsa5GgyVj98AunnYrTGFbIebivjQFTuGcC2LCdg_GLJkED01NGjfucz8TKJjCj8Gxa3QnH2ZcipuWUhWVUHPvgzHZe-w_TxeDOeywhDMKI9JWA2QiUM3pBtOpFLqmbd_dl7WMBDD_lw7xutd_UJTam_iuLegrr12cuEQJittPjU2a4YQ5SAqRcKbatpWFDrDsthws-65VTYSGgffeaODxqhQccffxpsoZpNQ9z5y6dydLbm02KFtQyjGQVkVztr00IBlvROvpALKGf8X4W1ZGeg7zEvsV8kyP084k_hUI6MWh6wqkVnF7SSV17RYtyumC1lq5VI-JdGn_YuyA7BZl4_Sgz8_fgeNXiC8z0qifLgrN2sczIe0CffI8piaJcUPxk8ADXBieKFniP5f3dG-AMDN8STr-B2nwFB_CNY7UDz76_s3FmVEnQTTU7MFqF5px-0ZgJhAJhWrOpAY93WGxfVRThfuMY1iGn-6_uuf6IrNAv5Cy7aGvagtrsi7F_UfGjbVbbB4bxQbcV-UqIHZP5wcgNU1JIW4Bztfjw5QUTidafK0ARwixIms3w1Dry4-O0KV-eksKbVrMtPAcL4GiiBaiuU-mpMDiT_c0yf2rCBeMOK_bAmkp7i8lrRMUQC4xYvav6-BDs8r3iuHEbvyBhO7i9Dlq1d5yT40AfmLvRs0lfU9S1d6_ltRRv3sNgUcuUiNxAMwHkco_LDoBxGg21-QCK6CahMJws-V4L60V7M-dRsIuhkIvCs0D7tSFmhBLMd33XEbOE0Jy79l0AgNMG0ChJPg8dvdSjBQ3ep_vAjQTgxJ_vWTy05yCwl6mFTl1zJWxcyjydP40t8D9SdAIQFXOXsxOaOGkauQGkO8t9igDMGIFCQWRJBW4JDC77EmIG3xHmhUnOZTUOmk2Y13SsSePHqLvXpEImCh-lG_Ehp5TgbK_mBfUUDOpZqSnEc3lHGC4z-9XMeOIGWYX689D07wskrtyNdEzShvTXWgrEPopU8c-D2XFw8X89i4f9wlVJ-Egn29eAhBCw4XaLwAA7_LUOXEVwlhYb7DmYxADRH_zXMl9gZE9_UJ_LkymE5ZoEMDT2mTv7cEUK9LPYkEBRmViKwxiFHwx2coDptiwVoR4-mLvPA7hzxRe7NjcreMJ6BEtpvhi4DwXeosAyHVQxd8R_Am7rw5Dtt5eap7Oca07-DDGWzSUzvpzt2Hde-_3NmrBxpOditdoDCuddXrXvyKByMIQmWnRtvIVhGgnGMjvYAkwNJBrd-1qxORsRMbhiBGX_l8HzgAYb6vuHjiaBhbo4a5_F-whRFJW1rO919s5ItElRg8Y6R3xI3xtKl3tza9Al_rKSvZ8lkiv44cUZ6a_rO8Zmi97pNd_aEgj1JhawhSHN3WGHkf7v5TdRC0CAZaxfDUrA4XupbrYuT1lZN7rnd_iIWvTEG2cFR08BcGyw0R9Yg=w1701-h1166',
  ogType: 'website',
  date: '2024-01-30',
  tag1: '#SmartBuilding',
  tag2: '#Toanhathongminh',
  tag3: '#IoT',
  tag4: '#Theodoivitri',
  text: [
    {
      head: 'Smart Building là gì?',
      subHead: '',
      desc: 'Smart Building (Toà nhà thông minh) là những tòa nhà sử dụng các công nghệ như cảm biến IoT, Trí tuệ nhân tạo (AI) và hệ thống tự động hóa để kết nối và tích hợp các hệ thống khác nhau trong tòa nhà, từ đó tối ưu hóa vận hành. Thông qua đó, chúng nâng cao hiệu quả năng lượng, đồng thời cải thiện an toàn, tiện nghi và hiệu quả tổng thể của tòa nhà. Với những công nghệ này, tòa nhà có thể thu thập dữ liệu theo thời gian thực và tự động điều chỉnh các tiện ích khác nhau như chiếu sáng, sưởi ấm, làm mát và hệ thống an ninh. Smart Building vận hành thân thiện với môi trường và kinh tế bằng cách nâng cao hiệu quả năng lượng và tối ưu hóa tiêu thụ năng lượng. Chúng nâng cao sự tiện lợi cho người dùng và tối ưu hóa vận hành, quản lý tòa nhà, từ đó cung cấp một môi trường sống và làm việc tốt hơn.',
      dot: '',
    },
    {
      head: 'Những công nghệ chính của Smart Building',
      subHead: 'Công nghệ cảm biến',
      desc: 'Smart Building sử dụng đa dạng các cảm biến để giám sát môi trường bên trong và bên ngoài tòa nhà theo thời gian thực. Các cảm biến này phát hiện và thu thập dữ liệu về nhiệt độ, độ ẩm, ánh sáng, nồng độ carbon dioxide, mức độ bụi mịn, chuyển động, v.v. Ngoài ra, thông qua dữ liệu cảm biến và kết nối với các thiết bị khác, Smart Building cho phép trao đổi thông tin và điều khiển theo thời gian thực. Với công nghệ IoT, Smart Building có thể tích hợp nhiều hệ thống và thiết bị khác nhau để vận hành hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'RTLS (Real-Time Location System) ',
      desc: 'Công nghệ RTLS có thể theo dõi vị trí theo thời gian thực của thiết bị, hàng tồn kho, vật tư, v.v., trong Smart Building. Điều này mang lại cơ hội nhanh chóng phát hiện và quản lý các trường hợp hư hỏng, thất lạc hoặc cần bảo trì thiết bị.\nNếu xảy ra tình huống khẩn cấp trong Smart Building, công nghệ RTLS có thể được sử dụng để hướng dẫn hướng sơ tán và xác định vị trí của tất cả các đối tượng và nhân sự trong tòa nhà. Điều này giúp những người làm công tác cứu hộ hoặc đội ngũ ứng phó khẩn cấp có thể hành động hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Trí tuệ nhân tạo (AI)',
      desc: 'Công nghệ Trí tuệ nhân tạo được sử dụng để cải thiện hệ thống tự động hóa và phân tích Big Data của Smart Building. AI giúp điều chỉnh hệ thống theo dữ liệu thay đổi theo thời gian thực và tối ưu hóa để phù hợp với nhu cầu người dùng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích Big Data',
      desc: 'Dữ liệu thu thập được sử dụng để nhận diện các mẫu và phát triển mô hình dự đoán thông qua công nghệ phân tích Big Data. Điều này giúp tối ưu hóa vận hành tòa nhà và phát hiện sớm các vấn đề.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Digital Twin',
      desc: 'Digital Twin là bản sao kỹ thuật số của mô hình vật lý của một tòa nhà thực. Nó mô phỏng chính xác tòa nhà trong môi trường kỹ thuật số, giúp dễ dàng nắm bắt và quản lý tổng thể. Mô hình kỹ thuật số này hỗ trợ vận hành và bảo trì tòa nhà, đồng thời phản ánh trạng thái thực tế của tòa nhà theo thời gian thực để chẩn đoán và dự đoán các vấn đề.',
      dot: '',
    },
    {
      head: 'Ưu điểm của Smart Building',
      subHead: '',
      desc: 'Smart Building mang lại nhiều ưu điểm thông qua sự hội tụ của công nghệ kiến trúc hiện đại và công nghệ thông tin và truyền thông. Những ưu điểm này thể hiện ở nhiều khía cạnh như vận hành tòa nhà, hiệu quả, tiện nghi và bảo vệ môi trường.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nâng cao hiệu quả năng lượng',
      desc: 'Smart Building tối ưu hóa việc sử dụng năng lượng thông qua các cảm biến và hệ thống tự động hóa. Ví dụ, hệ thống chiếu sáng, sưởi ấm, làm mát được điều chỉnh dựa trên dữ liệu thời gian thực, giúp giảm tiêu thụ năng lượng và nâng cao hiệu quả năng lượng. Ngoài ra, việc sử dụng phân tích Big Data và AI để thực hiện bảo trì dự đoán và dự báo mức tiêu thụ năng lượng cũng giúp giảm chi phí năng lượng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Thân thiện với môi trường',
      desc: 'Với việc tăng cường hiệu quả năng lượng, Smart Building giảm lượng khí thải nhà kính. Smart Building giám sát và quản lý bụi mịn và ô nhiễm không khí, từ đó cải thiện chất lượng không khí và tạo ra một môi trường lành mạnh.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giảm chi phí',
      desc: 'Cải thiện hiệu quả năng lượng giúp giảm chi phí năng lượng, đồng thời hệ thống tự động hóa giúp giảm chi phí nhân lực và tối ưu hóa chi phí bảo trì và vận hành.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tiện nghi và an toàn',
      desc: 'Smart Building nâng cao sự tiện lợi cho người dùng. Người dùng có thể thoải mái sử dụng tòa nhà nhờ việc tự động điều chỉnh hệ thống chiếu sáng, sưởi ấm, làm mát và an ninh. Hệ thống an ninh giám sát môi trường bên trong và bên ngoài Smart Building để ngăn chặn xâm nhập trái phép và chuẩn bị cho các tình huống khẩn cấp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giám sát và quản lý theo thời gian thực',
      desc: 'Smart Building cung cấp dữ liệu và cảnh báo theo thời gian thực cho nhà điều hành tòa nhà, giúp họ giải quyết vấn đề nhanh chóng hơn. Nhờ đó, có thể giám sát tình trạng sức khỏe của tòa nhà và tối ưu hóa lịch trình bảo trì.',
      dot: '',
    },
    {
      head: 'Các trường hợp ứng dụng Smart Building',
      subHead: 'The Edge, Amsterdam, Hà Lan',
      desc: 'The Edge là một Smart Building đổi mới nằm ở Amsterdam, Hà Lan, được coi là một trong những tòa nhà có hiệu quả năng lượng tốt nhất. Hàng trăm cảm biến được lắp đặt bên trong tòa nhà để tối ưu hóa hệ thống chiếu sáng, sưởi ấm, làm mát, và hoạt động theo vị trí và hoạt động của người dùng. Thông qua dữ liệu thời gian thực và phân tích Big Data, nó quản lý tiêu thụ năng lượng của tòa nhà và cung cấp nhiều dịch vụ khác nhau để tăng sự tiện lợi cho nhân viên.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Microsoft Campus, Redmond, Hoa Kỳ',
      desc: 'Microsoft Campus quản lý các tòa nhà và cơ sở vật chất bằng cách sử dụng công nghệ Smart Building và quản lý cơ sở vật chất thông minh. Tòa nhà này sử dụng cảm biến IoT và phân tích Big Data để tối ưu hóa quản lý hệ thống làm mát, sưởi ấm, chiếu sáng và nước, từ đó giảm chi phí năng lượng. Nhờ đó, nó cung cấp dịch vụ bên trong tòa nhà cho người dùng và tăng cường hệ thống bảo mật, nâng cao tiện nghi và an toàn cho nhân viên và khách.',
      dot: '',
    },
    {
      head: '',
      subHead: 'One Angel Square, Manchester, Anh Quốc',
      desc: 'One Angel Square, trụ sở chính của Co-operative Group tại Anh, tích cực sử dụng công nghệ Smart Building. Tòa nhà này tích hợp hệ thống năng lượng địa nhiệt, năng lượng mặt trời và năng lượng thân thiện với môi trường để tối ưu hóa nhiệt độ và môi trường của tòa nhà nhằm đạt hiệu quả năng lượng cao. Đồng thời, nó thu thập dữ liệu thời gian thực bằng cách sử dụng các cảm biến bên trong và bên ngoài tòa nhà, và quản lý vận hành tòa nhà thông qua phân tích Big Data.',
      dot: '',
    },
    {
      head: 'Triển vọng của Smart Building',
      subHead: '',
      desc: 'Smart Building trong tương lai được dự đoán sẽ nhấn mạnh hiệu quả năng lượng, và có thể vận hành tối ưu bằng cách sử dụng Big Data và Trí tuệ nhân tạo (AI). Sự phổ biến của công nghệ IoT và mạng lưới cảm biến sẽ cho phép giám sát và điều chỉnh theo thời gian thực, tối đa hóa sự tiện lợi cho người dùng. Ngoài ra, nó được dự kiến sẽ cung cấp một môi trường an toàn hơn với hệ thống bảo mật không có lỗi. Smart Building sẽ đóng vai trò trung tâm của các thành phố và tòa nhà trong tương lai, góp phần nâng cao hiệu quả năng lượng và tính thân thiện với môi trường. Những đặc điểm này sẽ thay đổi một cách cách mạng việc vận hành tòa nhà và trải nghiệm người dùng.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/vi/enterprise/construction/equipment',
      },
    ],
  },
};
